import { Stack } from "@mui/material";
import type React from "react";

interface BaseCardProps extends React.ComponentProps<typeof Stack> {
  children?: React.ReactNode;
}

/**
 * Simple white card with rounded corners and some padding, use as base for other card components
 */
export const BaseCard: React.FC<BaseCardProps> = ({
  children,
  ...stackProps
}) => {
  return (
    <Stack
      bgcolor={"white"}
      borderRadius={1}
      sx={{
        paddingX: stackProps.paddingX ?? { xs: 2, sm: 4 },
        paddingY: stackProps.paddingY ?? 4,
      }}
      {...stackProps}
    >
      {children}
    </Stack>
  );
};
